export function Logo({ size = "md", className = "" }) {
  const sz = size === "lg" ? "text-3xl" : size === "sm" ? "text-lg" : "text-xl";
  return (
    <div data-testid="ns-logo" className={`font-display font-bold tracking-tight ${sz} ${className}`}>
      <span className="text-white">Next</span><span className="gold-text">Scene</span>
    </div>
  );
}
